import { formatDate } from '@/lib/utils';

/** Normaliza hora do banco (HH:mm:ss) ou formulário (HH:mm) */
export function normalizeHoraAgendamento(hora?: string | null): string | null {
  if (!hora) return null;
  const trimmed = hora.trim();
  if (!trimmed) return null;
  return trimmed.slice(0, 5);
}

/**
 * Exibe data + hora do agendamento sem conversão de fuso.
 * Mesmo padrão de agendamentos: data_agendamento (date) + hora_agendamento (time).
 */
export function formatAgendamentoCard(
  dataAgendamento?: string | null,
  horaAgendamento?: string | null
): string | null {
  if (!dataAgendamento) return null;

  const data = formatDate(dataAgendamento);
  const hora = normalizeHoraAgendamento(horaAgendamento);

  return hora ? `${data} ${hora}` : data;
}
